// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signature[data-v-8740b952]{border:1px solid;border-radius:4px}h1[data-v-8740b952]{font-size:18px}h2[data-v-8740b952]{font-size:14px}h3[data-v-8740b952]{font-size:12px}.pdf[data-v-8740b952]{font-size:10px;width:595px;background-color:#fff;margin:0 auto;padding:12px}.bordered[data-v-8740b952]{border-top:1px solid;border-bottom:1px solid}", ""]);
// Exports
module.exports = exports;
